export const OPEN_MODAL_EVENT = 'open'
export const CLOSE_MODAL_EVENT = 'close'
export const CANCEL_MODAL_EVENT = 'cancel'
export const CONFIRM_MODAL_EVENT = 'confirmar'
export const CANCEL_BUTTON_MODAL_EVENT = 'cancelar'

export const DEFAULT_TAGGINGS = {
    [OPEN_MODAL_EVENT]: {
        categoriaEvento: window.utag_data.tipoProceso,
        accionEvento: "modal cancelar solicitud",
        etiquetaEvento: "vista"
    },
    [CLOSE_MODAL_EVENT]: {
        categoriaEvento: window.utag_data.tipoProceso,
        accionEvento: 'modal cancelar solicitud',
        etiquetaEvento: 'cerrar',
    },
    [CANCEL_MODAL_EVENT]: {
        categoriaEvento: window.utag_data.tipoProceso,
        accionEvento: 'modal cancelar solicitud',
        etiquetaEvento: 'cerrar',
    },
    [CANCEL_BUTTON_MODAL_EVENT]: {
        categoriaEvento: window.utag_data.tipoProceso,
        accionEvento: 'modal cancelar solicitud',
        etiquetaEvento: 'cancelar',
    },
    [CONFIRM_MODAL_EVENT]: {
        categoriaEvento: window.utag_data.tipoProceso,
        accionEvento: "modal cancelar solicitud",
        etiquetaEvento: "continuar mas tarde"
    },  
}
